// Gateway API
import {
    RequestConfigFunction,
} from 'app/types/request.types'

type GatewayRequests = {
    domainName: string,
    get: RequestConfigFunction<{id: number}>,
    modifications: RequestConfigFunction<{id: number}>,
    update: RequestConfigFunction<{id: number}>,
    create: RequestConfigFunction<{id: number}>,
    filterRequest: RequestConfigFunction<Record<string, any>>,
    workSchedule?: RequestConfigFunction<{id: number}>,
}

const gatewayRequests: GatewayRequests = {
    domainName: 'Gateway',
    filterRequest: ({
        params,
    }) => {
        return {
            url: 'gateway/filter-request/all',
            method: 'POST',
            ...params,
        }
    },
    get: ({
        id,
    }) => {
        return {
            url: `gateway/${id}`,
            method: 'GET',
        }
    },
    update: () => {
        return {
            url: 'gateway',
            method: 'PUT',
            domainName: 'Gateway',
        }
    },
    create: () => {
        return {
            url: 'gateway',
            method: 'POST',
            domainName: 'Gateway',
        }
    },
    modifications: ({
        id,
    }) => {
        return {
            url: `gateway/${id}/modifications`,
            method: 'GET',
        }
    },
    workSchedule: ({
        id,
    }) => {
        return {
            url: `gateway/${id}/work-schedule`,
            method: 'PATCH',
        }
    },
}

export default gatewayRequests
